var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"boostBtn",class:{ active: _vm.activated && !_vm.disable, disable: _vm.disable },attrs:{"x-small":"","rounded":"","outlined":"","disabled":_vm.disable},on:{"click":_vm.boostActivation}},[_vm._v("boost")])}
var staticRenderFns = []

export { render, staticRenderFns }